import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    givenName: {
        "label": "Prénom",
        "optionsPlaceholder": "Charles"
    },
    familyName: {
        "label": "Nom",
        "optionsPlaceholder": "Dupont"
    },
    email: {
        "label": "Adresse mail",
        "optionsPlaceholder": "charles.dupont@activmed.com"
    },
    phoneNumber: {
        "label": "Téléphone",
        "optionsPlaceholder": "+33XXXXXXXXX"
    },
    genderMale: { civility: { val: "M." }, gender: { val: "M" } },
    genderFemale: { civility: { val: "Mme" }, gender: { val: "F" } },
    birthDate: {
        "label": "Date de naissance",
        "optionsPlaceholder": "14/01/1971"
    },
    civility: { "label": "Civilité" },
    gender: { label: "Sexe" },
    status: { label: "statut" },
    genderEmpty: { "label": "Sélectionner" },
    city: {
        "label": "Ville",
        "optionsPlaceholder": "Moulinsart"
    },
    postalCode: {
        "label": "Code postal",
        "optionsPlaceholder": "41700"
    },
    nir: {
        "label": "Numéro de sécurité sociale",
        "optionsPlaceholder": "1 xx xx xx xxx xxx xx"
    },
    daysOfWeek: {
        monday: { val: "lundi" },
        tuesday: { val: "mardi" },
        wednesday: { val: "mercredi" },
        thursday: { val: "jeudi" },
        friday: { val: "vendredi" },
        saturday: { val: "samedi" },
        sunday: { val: "dimanche" }
    },
    medGroupPhoneNumber: {
        "label": "Téléphone de la structure",
        "optionsPlaceholder": "+33XXXXXXXXX"
    },
    streetNumber: {
        "label": "Adresse de la structure",
        "optionsPlaceholder": "10 rue des Magnolias"
    },
    siret: {
        "label": "Numéro Siret",
        "optionsPlaceholder": "xxx xxx xxx xxxxx"
    },
    medGroupeName: {
        "label": "Nom de la structure",
        "optionsPlaceholder": "ActivMed"
    },
    idMss: {
        label: "Identifiant MSS du patient"
    }
};

export type _I18nPatient = typeof _fr;

const _en: _I18nPatient = {
    givenName: {
        "label": "Given Name",
        "optionsPlaceholder": "John"
    },
    familyName: {
        "label": "Family Name",
        "optionsPlaceholder": "Doe"
    },
    email: {
        "label": "Email",
        "optionsPlaceholder": "john.doe@activmed.com"
    },
    phoneNumber: {
        "label": "Phone number",
        "optionsPlaceholder": "+44XXXXXXXXX"
    },
    genderMale: { civility: { val: "Mister" }, gender: { val: "M" } },
    genderFemale: { civility: { val: "Miss" }, gender: { val: "F" } },
    birthDate: {
        "label": "Birth date",
        "optionsPlaceholder": "14/01/1971"
    },
    civility: { "label": "Civilité" },
    gender: { label: "Sexe" },
    status: { label: "status" },
    genderEmpty: { "label": "Select" },
    city: {
        "label": "City",
        "optionsPlaceholder": "London"
    },
    postalCode: {
        "label": "Postal code",
        "optionsPlaceholder": "41700"
    },
    nir: {
        "label": "Social security number",
        "optionsPlaceholder": "x xx xx xx xxx xxx xx"
    },
    daysOfWeek: {
        monday: { val: "monday" },
        tuesday: { val: "tuesday" },
        wednesday: { val: "wednesday" },
        thursday: { val: "thursday" },
        friday: { val: "friday" },
        saturday: { val: "saturday" },
        sunday: { val: "saturday" }
    },
    medGroupPhoneNumber: {
        "label": "Phone number of the group",
        "optionsPlaceholder": "+44XXXXXXXXX"
    },
    streetNumber: {
        "label": "Street number",
        "optionsPlaceholder": "99 bis Park Lane"
    },
    siret: {
        "label": "Siret number",
        "optionsPlaceholder": "x xx xx xx xxx xxx xx"
    },
    medGroupeName: {
        "label": "Name of the group",
        "optionsPlaceholder": "ActivMed"
    },
    idMss: {
        label: "MSS identifier"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nPatient(lang?: string): _I18nPatient {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}